// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.5_@rspack+core@2.2.3_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eZ9wDlg1AKZd8x {
  margin: var(--ds-space-0, 0) -12px;
}

.eZ9wDlg1AKZd8x > ul {
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  list-style: none;
}

.vcZC6z3fGQKP2O, .lkpSVVdFCM6fff {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  margin: var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  background-color: #0000;
  background: var(--ds-background-neutral-subtle, #0000);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-align: left;
  border: none;
  border-radius: 0;
  outline: none;
  text-decoration: none;
  transition: none;
  display: block;
}

.vcZC6z3fGQKP2O:after, .lkpSVVdFCM6fff:after {
  display: none;
}

.vcZC6z3fGQKP2O:hover, .lkpSVVdFCM6fff:hover {
  box-shadow: none;
  background-color: #0000;
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
  border: none;
  text-decoration: none;
}

.vcZC6z3fGQKP2O:hover:after, .lkpSVVdFCM6fff:hover:after {
  display: none;
}

.vcZC6z3fGQKP2O:active, .lkpSVVdFCM6fff:active {
  box-shadow: none;
  background-color: #0000;
  background: var(--ds-background-neutral-subtle-pressed, #091e4224);
  color: var(--ds-text, #172b4d);
  border: none;
}

.vcZC6z3fGQKP2O:active:after, .lkpSVVdFCM6fff:active:after {
  display: none;
}

.vcZC6z3fGQKP2O.SRIs0QiV7TI2Kf:focus, .lkpSVVdFCM6fff.SRIs0QiV7TI2Kf:focus {
  outline: var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #388bff);
  outline-offset: 2px;
  outline-offset: -1px;
}

:is(.mac .vcZC6z3fGQKP2O.SRIs0QiV7TI2Kf:focus, .mac .lkpSVVdFCM6fff.SRIs0QiV7TI2Kf:focus) {
  outline-color: -webkit-focus-ring-color;
}

:is(.vcZC6z3fGQKP2O.SRIs0QiV7TI2Kf:focus .mac.firefox, .lkpSVVdFCM6fff.SRIs0QiV7TI2Kf:focus .mac.firefox) {
  outline-color: accentcolor;
}

.vcZC6z3fGQKP2O[disabled], .lkpSVVdFCM6fff[disabled], .vcZC6z3fGQKP2O[disabled]:active, .lkpSVVdFCM6fff[disabled]:active, .vcZC6z3fGQKP2O[disabled]:focus, .lkpSVVdFCM6fff[disabled]:focus, .vcZC6z3fGQKP2O[disabled]:hover, .lkpSVVdFCM6fff[disabled]:hover {
  cursor: not-allowed;
  background: none;
  color: var(--ds-text-disabled, #091e424f) !important;
}

.vcZC6z3fGQKP2O[disabled] .K1LDOAVFJVYH4b svg, .lkpSVVdFCM6fff[disabled] .K1LDOAVFJVYH4b svg, .vcZC6z3fGQKP2O[disabled]:active .K1LDOAVFJVYH4b svg, .lkpSVVdFCM6fff[disabled]:active .K1LDOAVFJVYH4b svg, .vcZC6z3fGQKP2O[disabled]:focus .K1LDOAVFJVYH4b svg, .lkpSVVdFCM6fff[disabled]:focus .K1LDOAVFJVYH4b svg, .vcZC6z3fGQKP2O[disabled]:hover .K1LDOAVFJVYH4b svg, .lkpSVVdFCM6fff[disabled]:hover .K1LDOAVFJVYH4b svg {
  color: var(--ds-text-disabled, #091e424f) !important;
}

.vcZC6z3fGQKP2O[disabled] span[name="check"], .lkpSVVdFCM6fff[disabled] span[name="check"], .vcZC6z3fGQKP2O[disabled]:active span[name="check"], .lkpSVVdFCM6fff[disabled]:active span[name="check"], .vcZC6z3fGQKP2O[disabled]:focus span[name="check"], .lkpSVVdFCM6fff[disabled]:focus span[name="check"], .vcZC6z3fGQKP2O[disabled]:hover span[name="check"], .lkpSVVdFCM6fff[disabled]:hover span[name="check"] {
  color: var(--ds-icon-subtle, #626f86) !important;
}

.vcZC6z3fGQKP2O[disabled] .VSCwfNks7gNEyH, .lkpSVVdFCM6fff[disabled] .VSCwfNks7gNEyH, .vcZC6z3fGQKP2O[disabled]:active .VSCwfNks7gNEyH, .lkpSVVdFCM6fff[disabled]:active .VSCwfNks7gNEyH, .vcZC6z3fGQKP2O[disabled]:focus .VSCwfNks7gNEyH, .lkpSVVdFCM6fff[disabled]:focus .VSCwfNks7gNEyH, .vcZC6z3fGQKP2O[disabled]:hover .VSCwfNks7gNEyH, .lkpSVVdFCM6fff[disabled]:hover .VSCwfNks7gNEyH {
  color: var(--ds-text-disabled, #091e424f) !important;
}

._0NcsHb4QL9js7 {
  padding-right: calc(var(--ds-space-800, 64px) + var(--ds-space-500, 40px));
}

.RlZgMs4EE0MdMY {
  justify-content: space-between;
  column-gap: var(--ds-space-100, 8px);
  width: 100%;
  font-size: 14px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 20px;
  display: flex;
}

.RlZgMs4EE0MdMY.G7DaLOfL666RQo {
  margin: var(--ds-space-0, 0);
}

.RlZgMs4EE0MdMY.Lf_Ykw9FM_goZx {
  align-items: center;
}

.RlZgMs4EE0MdMY.ikWUeCyZBpQ_i8 {
  align-items: flex-start;
}

.RlZgMs4EE0MdMY.E7UDs81mgRAky7 .VSCwfNks7gNEyH {
  color: var(--ds-text-disabled, #091e424f);
}

.P8V1fJ2OaEWLfS {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
}

.f50Oe_b4iNpHJ2 {
  box-sizing: border-box;
  width: 100%;
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0);
  padding: var(--ds-space-075, 6px) var(--ds-space-150, 12px);
  cursor: pointer;
  display: flex;
}

.f50Oe_b4iNpHJ2 > .RlZgMs4EE0MdMY {
  align-items: flex-start;
}

.f50Oe_b4iNpHJ2:hover {
  background: var(--ds-background-neutral-subtle-hovered, #091e420f);
  color: var(--ds-text, #172b4d);
}

.f50Oe_b4iNpHJ2:has(.nZH8aT4UDuzfod:focus-visible) {
  outline: var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #388bff);
  outline-offset: 2px;
  outline-offset: -1px;
}

.mac .f50Oe_b4iNpHJ2:has(.nZH8aT4UDuzfod:focus-visible) {
  outline-color: -webkit-focus-ring-color;
}

.f50Oe_b4iNpHJ2:has(.nZH8aT4UDuzfod:focus-visible) .mac.firefox {
  outline-color: accentcolor;
}

.f50Oe_b4iNpHJ2.E7UDs81mgRAky7 {
  cursor: not-allowed;
  background: none;
  color: var(--ds-text-disabled, #091e424f) !important;
}

.f50Oe_b4iNpHJ2.E7UDs81mgRAky7 .VSCwfNks7gNEyH {
  color: var(--ds-text-disabled, #091e424f) !important;
}

.f50Oe_b4iNpHJ2 .nZH8aT4UDuzfod {
  opacity: 0;
  display: block;
  position: absolute;
}

.f50Oe_b4iNpHJ2 .K1LDOAVFJVYH4b {
  opacity: 0;
  flex: none;
}

.f50Oe_b4iNpHJ2 .nZH8aT4UDuzfod:checked ~ .K1LDOAVFJVYH4b {
  opacity: 1;
}

.f50Oe_b4iNpHJ2 .OLrZdmF9J6B0T9 {
  flex: auto;
  max-width: fit-content;
}

.t8Fi3vU7G949Jt {
  flex-direction: column;
  flex: auto;
  align-items: flex-start;
  display: flex;
}

.s94D2cTdemg0g1 {
  word-break: break-word;
  display: flex;
}

.ECx9XVA3UXwRZy, .unw8Yny8El9cC1 {
  max-height: 20px;
  padding: var(--ds-space-0, 0) var(--ds-space-050, 4px);
  flex-shrink: 0;
}

.VSCwfNks7gNEyH {
  margin: var(--ds-space-050, 4px) var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-0, 0);
  padding: var(--ds-space-0, 0);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  font-weight: var(--ds-font-weight-regular, 400);
  line-height: 16px;
}

.HcGMaqv_9ytx0G {
  list-style: none;
}

.HcGMaqv_9ytx0G:after {
  content: " ";
  height: 1px;
  margin: var(--ds-space-100, 8px) var(--ds-space-150, 12px);
  background-color: var(--ds-border, #091e4224);
  display: block;
}

.oeJvQqNlVEUeDm:after {
  margin-right: var(--ds-space-0, 0);
  margin-left: var(--ds-space-0, 0);
}

.PtFIWbBYRtBRJ6 {
  list-style: none;
}

.QwKOkwZffmFwja {
  position: relative;
}

.g99DEHB1TNzAL9 {
  top: 50%;
  right: var(--ds-space-150, 12px);
  align-items: center;
  display: flex;
  position: absolute;
  transform: translateY(-50%);
}
`, ""]);
// Exports
export var popoverMenu = `eZ9wDlg1AKZd8x`;
export var button = `vcZC6z3fGQKP2O`;
export var link = `lkpSVVdFCM6fff`;
export var focusRing = `SRIs0QiV7TI2Kf`;
export var icon = `K1LDOAVFJVYH4b`;
export var description = `VSCwfNks7gNEyH`;
export var buttonWithElementAfter = `_0NcsHb4QL9js7`;
export var item = `RlZgMs4EE0MdMY`;
export var withoutMargins = `G7DaLOfL666RQo`;
export var alignCenter = `Lf_Ykw9FM_goZx`;
export var alignStart = `ikWUeCyZBpQ_i8`;
export var disabled = `E7UDs81mgRAky7`;
export var textItem = `P8V1fJ2OaEWLfS`;
export var radio = `f50Oe_b4iNpHJ2`;
export var input = `nZH8aT4UDuzfod`;
export var content = `OLrZdmF9J6B0T9`;
export var title = `t8Fi3vU7G949Jt`;
export var titleText = `s94D2cTdemg0g1`;
export var iconBefore = `ECx9XVA3UXwRZy`;
export var iconAfter = `unw8Yny8El9cC1`;
export var separator = `HcGMaqv_9ytx0G`;
var _1 = `oeJvQqNlVEUeDm`;
export { _1 as "separator--fullWidth" };
export var listItem = `PtFIWbBYRtBRJ6`;
export var listItemWithElementAfter = `QwKOkwZffmFwja`;
export var elementAfter = `g99DEHB1TNzAL9`;
export default ___CSS_LOADER_EXPORT___;
